import { COMPOSED_OF } from '~/scripts/constants/common-kids';

/**
 * @memberOf app
 * @ngdoc service
 * @name app.Scenario (script)
 * @description
 * # Scenario (script)
 * Factory in the app.
 */
angular.module('app')
	.factory('Scenario', /* @ngInject */ () => {
		class Scenario {
			constructor(headers, structure, config, masterArray) {
				this.SCRIPT = [];
				this.VALUES = [];
				this.CONFIG = [];
				this.writeScenario(headers, structure, config, masterArray);
			}

			writeScript(headers, structure, config, mcid, originalMc) {
				let rootKey = '';
				const originalTemplate = angular.copy(config[mcid]);
				const template = angular.copy(config[mcid]);

				// Remake template without all conf opts
				/**
				 * @param temporary
				 */
				function cleanTemplate(temporary) {
					const t = {
						kisa: temporary.kisa,
					};

					if (temporary.bloc_list !== undefined) {
						t.bloc_list = temporary.bloc_list;
					}

					return t;
				}

				// Trouve un element parmis les headers (key = "K_NODE;CLASSE_lvl_masterClassUnique")
				/**
				 * @param key
				 */
				function findHeader(key) {
					let found = {};

					angular.forEach(headers, head => {
						// console.log("headers,", head)
						if (head.asso[mcid].path[head.asso[mcid].path.length - 1].id === key) {
							found = head;
						}
					});
					return found;
				}

				/**
				 * @param key
				 */
				function headerBloc(key) {
					// console.log("headerbloc", key)
					/// /console.log("headerbloc", originalTemplate[key]);
					let hb = {};
					const head = findHeader(key);

					// console.log("head", head)

					if (!angular.equals({}, head)) {
						hb = {
							bloc: 'KREPRE',
							actif: originalTemplate[key].opt.active,
							on_empty: originalTemplate[key].opt.on_empty,
							kaction: 'SET',
							klang: originalTemplate[key].opt.language[0].kid,
							kname: {
								action_list: [
							    	{
							    		action: '_SET_VALUE_BY_INDEX_',
							    		index: head.i,
							    		name: 'headerbloc called',
							    	},
							    ],
							},
						};
					}

					return hb;
				}

				// Return bloc options
				/**
				 * @param opt
				 */
				function blocOptions(opt) {
					const options = {
						on_empty: opt.on_empty,
						actif: opt.active,
					};

					return options;
				}

				// Traitement de chaque action
				/**
				 * @param bloc
				 */
				function actionArray(bloc) {
					// Dictionnaire des actions

					// _SET_VALUE_BY_INDEX_
					/**
					 * @param action
					 */
					function actSetValueByIndex(action) {
						const col = {
							i: action.params.index,
							n: action.params.name,
						};

						if (action.params.index === 'defaut' || action.params.name === 'defaut') {
							const h = findHeader(bloc.id);
							/* if (angular.equals(h, {})) {
								h = findHeader(bloc.id)
							} */

							col.i = h.i;
							col.n = h.n;
						}

						const a =	{
							actif: action.params.actif,
							action: '_SET_VALUE_BY_INDEX_',
							index: col.i,
							name: col.n,
						};

						return a;
					}

					// _IF_
					/**
					 * @param action
					 */
					function actCondition(action) {
						const a = {
							actif: action.params.actif,
							action: '_IF_',
							champ: action.params.element,
							ope: action.params.operator,
							value: action.params.value,
							then: action.params.then,
							else: action.params.else,
						};

						return a;
					}

					// _SET_KID_
					/**
					 * @param action
					 */
					function act_SET_KID_(action) {
						const a = {
							actif: action.params.actif,
							action: '_SET_KID_',
							kid: action.params.kid,
						};

						return a;
					}

					// _SET_VALUE_
					/**
					 * @param action
					 */
					function act_SET_VALUE_(action) {
						const a = {
							actif: action.params.actif,
							action: '_SET_VALUE_',
							value: action.params.value,
						};

						return a;
					}

					// _FIND_
					/**
					 * @param action
					 */
					function act_FIND_(action) {
						let lang = 'K_NODE;UNIVERSEL';
						if (action.language !== undefined && action.language !== 'K_NODE;UNIVERSEL') {
							if (angular.isArray(action.language)) {
								if (action.language.length > 0 && action.language[0].kid !== undefined) {
									lang = `K_NODE;${action.language[0].kid}`;
								}
							}
						}

						const a = {
							actif: action.params.actif,
							action: '_FIND_',
							kisa: action.params.kisa,
							REPRE: lang,
							LINK: [
								{
									linker_kid: '0', relation_kid: COMPOSED_OF, objnum2: '_SELF_', objnum2_isa: '_SELF_',
								},
							],
							on_find: action.params.on_find,
							on_not_find: action.params.on_not_find,
						};

						return a;
					}

					// _FIND_BY_REPRE_
					/**
					 * @param action
					 */
					function act_FIND_BY_REPRE_(action) {
						let lang = 'K_NODE;UNIVERSEL';
						if (action.language !== undefined && action.language !== 'K_NODE;UNIVERSEL') {
							if (angular.isArray(action.language)) {
								if (action.language.length > 0 && action.language[0].kid !== undefined) {
									lang = `K_NODE;${action.language[0].kid}`;
								}
							}
						}

						const a = {
							actif: action.params.actif,
							action: '_FIND_BY_REPRE_',
							lang_kid: 'K_NODE;UNIVERSEL',
							kisa: lang,
							on_find: action.params.on_find,
							on_not_find: action.params.on_not_find,
						};

						return a;
					}

					// _EXIST_KID_
					/**
					 * @param action
					 */
					function act_EXIST_KID_(action) {
						const a = {
							actif: action.params.actif,
							action: '_EXIST_KID_',
						};

						return a;
					}

					// console.log("Bloc Pour action", bloc)
					const action_list = [];

					angular.forEach(bloc.actions, (action, actionKey) => {
						// console.log("ACTION ACTION", action);

						let act = {};
						// Redirection pour chaque action
						if (action.name === 'setValueByIndex') {
							act = actSetValueByIndex(action);
						}
						else if (action.name === 'condition') {
							act = actCondition(action);
						}
						else if (action.name === '_SET_KID_') {
							act = act_SET_KID_(action);
						}
						else if (action.name === '_SET_VALUE_') {
							act = act_SET_VALUE_(action);
						}
						else if (action.name === '_FIND_') {
							act = act_FIND_(action);
						}
						else if (action.name === '_FIND_BY_REPRE_') {
							act = act_FIND_BY_REPRE_(action);
						}
						else if (action.name === '_EXIST_KID_') {
							act = act_EXIST_KID_(action);
						}

						action_list.push(act);
					});

					return action_list;
				}

				/**
				 * @param configBloc
				 * @param parent
				 * @param structureBloc
				 * @param structureParent
				 * @param tmpKey
				 * @param temporaryKey
				 */
				function newBlocInBlocList(configBloc, parent, structureBloc, structureParent, temporaryKey) {
					// console.log("newBlocInBlocList")
					const realTemplate = template[configBloc.id];
					/// /console.log("confbloc",confBloc);
					/// /console.log("realTemplate", realTemplate);
					let options = {};
					const bloc = {
						bloc: 'KLINK',
						kisa: `K_NODE;${configBloc.id.split('_')[0]}`,
						kaction: 'SET',
						krelation: COMPOSED_OF,
						// TODO : setLinker
						klinker: configBloc.linker_kid,
					};

					if (originalTemplate[configBloc.id].opt !== undefined) {
						// console.log("a", originalTemplate[confBloc.id])
						// console.log("a, bloc?", confBloc)
						/// /console.log("opt = ",confBloc.id, originalTemplate[confBloc.id].opt)
						if (configBloc.opt.templateMode === true) {
							// console.log("ab")
							bloc.kid = `#TEMPLATE:${configBloc.id}`;
							// // // realTemplate.bloc_list.push(headerBloc(confBloc.id));
						}
						else {
							// Si pas en mode template, mais un bloc a traiter quand même
							// console.log("ac")
							if (originalTemplate[configBloc.id].bloc_list.length > 0) {
								// console.log("aca", confBloc);
								bloc.kid = {};
								if (configBloc.actions !== undefined && configBloc.actions.length > 0) {
									bloc.kid.action_list = actionArray(configBloc);
								}

								// Language config
								let lang = 'K_NODE;UNIVERSEL';
								if (configBloc.opt.language !== undefined && configBloc.opt.language !== 'K_NODE;UNIVERSEL') {
									if (angular.isArray(configBloc.opt.language)) {
										if (configBloc.opt.language.length > 0 && configBloc.opt.language[0].kid !== undefined) {
											lang = `K_NODE;${configBloc.opt.language[0].kid}`;
										}
									}
								}

								bloc.klang = lang;
							}
							else {
								// console.log("acc")
								const header = findHeader(configBloc.id);
								// // // realTemplate.bloc_list.push(headerBloc(confBloc.id));

								bloc.kid = {
									action_list: [],
								};

								bloc.kid.action_list.push({
									action: '_SET_VALUE_BY_INDEX_',
									index: header.i,
									name: header.n,
								});

								delete template[configBloc.id];
							}
						}
					}

					if (configBloc.opt !== undefined) {
						// console.log("opts")
						options = blocOptions(configBloc.opt);
					}

					const finalBloc = Object.assign(bloc, options);
					/// /console.log("finalBloc,", finalBloc)
					return finalBloc;
				}

				// Return a json bloc for script
				/**
				 * @param configBloc
				 * @param blocListIdx
				 * @param parent
				 * @param structureBloc
				 * @param structureParent
				 * @param tmpKey
				 * @param temporaryKey
				 */
				function defaultBloc(configBloc, blocListIdx, parent, structureBloc, structureParent, temporaryKey) {
					/// /console.log("defaultBloc check", confBloc.id)
					/// /console.log("template[confBloc.id]", template[confBloc.id])
					const realTemplate = template[configBloc.id];
					/// /console.log("defaultBloc", confBloc);
					if (realTemplate !== undefined) {
						/// /console.log("defaultBloc bypass check")
						structureParent.bloc_list[blocListIdx] = newBlocInBlocList(configBloc, parent, structureBloc, structureParent, temporaryKey);
					}
				}

				/**
				 * @param bloc
				 * @param parentId
				 */
				function repreBloc(bloc, parentId) {
					// console.log("reprebloc", bloc)
					// console.log("originalTemplate", originalTemplate);
					// console.log("repretemplateopt", originalTemplate[bloc.id]);

					const repreAction = bloc.actions.find(x => x.name = 'setValueByIndex');
					// let parentTemplateId = bloc.id.replace('::krepre','');

					// console.log("parentId", parentId)
					// console.log()
					if (repreAction !== undefined) {
						// Header Index config
						const col = {
							i: repreAction.params.index,
							n: repreAction.params.name,
						};

						if (repreAction.params.index === 'defaut' || repreAction.params.name === 'defaut') {
							let h = findHeader(parentId);
							if (angular.equals(h, {})) {
								h = findHeader(bloc.id);
							}

							// console.log("LE H,", h)

							col.i = h.i;
							col.n = h.n;
						}

						// Language config
						let lang = 'K_NODE;UNIVERSEL';
						if (bloc.opt.language !== undefined && bloc.opt.language !== 'K_NODE;UNIVERSEL') {
							if (angular.isArray(bloc.opt.language)) {
								if (bloc.opt.language.length > 0 && bloc.opt.language[0].kid !== undefined) {
									lang = `K_NODE;${bloc.opt.language[0].kid}`;
								}
							}
						}

						const repre = {
							actif: bloc.opt.active,
							bloc: 'KREPRE',
							kaction: 'SET',
							klang: lang,
							on_empty: bloc.opt.on_empty,
							kname: {
								action_list: [
									{
										action: '_SET_VALUE_BY_INDEX_',
										index: col.i,
										name: col.n,
									},
								],
							},
						};

						return repre;
					}
				}

				/// /console.log("TEMPLATE", angular.copy(template));
				angular.forEach(template, (temporary, temporaryKey) => {
					if (temporary.displayTemplate === true || temporary.display === 'root') {
						/// /console.log("template parent", angular.copy(tmp), tmpKey);
						template[temporaryKey] = cleanTemplate(temporary);
						// console.log("template,", template)
						if (temporary.bloc_list !== undefined) {
							angular.forEach(temporary.bloc_list, (bloc, blocKey) => {
								// console.log("bloc", bloc, blocKey, originalTemplate, originalTemplate[tmpKey].bloc_list)
								if (bloc.id.split('::')[1] !== undefined && bloc.id.split('::')[1].includes('krepre')) {
									// console.log("Scenario -> c'est un krepre", bloc)
									delete template[bloc.id];
									template[temporaryKey].bloc_list[template[temporaryKey].bloc_list.findIndex(x => x.id === bloc.id)] = repreBloc(bloc, temporaryKey);
								}
								else {
									defaultBloc(bloc, blocKey, temporary, template[temporaryKey].bloc_list[blocKey], template[temporaryKey], temporaryKey);
								}
							});
						}
					}
					else {
						delete template[temporaryKey];
					}
				});

				// Définit la target (root template)
				angular.forEach(config[mcid], (configElement, configElementKey) => {
					if (configElement.display !== undefined) {
						if (configElement.display === 'root') {
							rootKey = configElementKey;
						}
					}
				});

				const script = {
					info: {
						type: 'FILE',
						data_file: 'dur',
						actif: originalMc[0].masterClassInfo.actif,
						name: originalMc[0].masterClassInfo.name,
						comment: originalMc[0].masterClassInfo.comment,
						start_line: originalMc[0].masterClassInfo.start_line,
					},

					target: rootKey,

					TEMPLATE: template,
				};

				return script;
			}

			writeValues(headers, structure, config, mcid, mc) {
				// Define tab value to save in json
				/**
				 * @param headers
				 */
				function setScriptHeaderValues(headers) {
					const cols = [];
					angular.forEach(headers, value => {
						cols.push({
							n: value.n,
							type: value.type,
							i: value.i,
							on_empty: value.on_empty,
							kid: value.asso[mcid].kid,
							path: value.asso[mcid].path,
							linker_kid: value.asso[mcid].linker_kid,
						});
					});
					return cols;
				}

				// Return a value bloc
				/**
				 * @param headers
				 * @param structure
				 * @param mc
				 */
				function setValueBloc(headers, structure, mc) {
					let root = '';
					angular.forEach(structure, (value, key) => {
						if (value.display === 'root') {
							root = value;
							root.unique = key;
						}
					});

					const valueBloc = {
						masterClass: root.kisa,
						start_line: mc[0].masterClassInfo.start_line,
						actif: mc[0].masterClassInfo.actif,
						name: mc[0].masterClassInfo.name,
						comment: mc[0].masterClassInfo.comment,
						masterClassUnique: root.unique.split('_')[1],
						headers: setScriptHeaderValues(headers),
					};

					return valueBloc;
				}

				const VALUES = setValueBloc(headers, structure, mc[0]);

				return VALUES;
			}

			writeConfig(headers, structure, config, mcid) {
				// TODO : delete "$$hashKey"
				const config_ = { [mcid]: angular.copy(config[mcid]) };
				angular.forEach(config_[mcid], v => {
					if (v.childs !== undefined) {
						v.expanded = false;
						v.addLink = false;
						delete v.childs;
					}
				});

				return config_;
			}

			writeScenario(headers, structure, config, masterArray) {
				const self = this;
				angular.forEach(structure, (struct, mcid) => {
					const filtredHeaders = [];
					const validHeaders = headers.filter(x => x.asso !== undefined);// .filter(x => x.asso.masterClassInfo.masterClassUnique === mcid);
					const mc = masterArray.filter(x => x[0].masterClassInfo.masterClassUnique === mcid);
					// Dispatch correctement les headers s'ils contiennent une asso qui va être utilisée par le script
					angular.forEach(validHeaders, vh => {
						angular.forEach(vh.asso, (a, aKey) => {
							if (aKey === mcid) {
								filtredHeaders.push(vh);
							}
						});
					});

					if (filtredHeaders.length !== 0) {
						self.SCRIPT.push(self.writeScript(filtredHeaders, struct, config, mcid, mc[0]));
					}
					self.VALUES.push(self.writeValues(filtredHeaders, struct, config, mcid, mc));
					self.CONFIG.push(self.writeConfig(filtredHeaders, struct, config, mcid));
				});
			}
		}

		return Scenario;
	});
